<template>
  <layout-content>
    <template #headerTitle>
      <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>
      <!--  查询表单  -->
      <div class="alarm-config-container">
        <el-form :inline="true" :model="search">
          <el-form-item label="加和因子名称">
            <el-select v-model="search.factorConfigId" size="small" style="width: 200px" placeholder="请选择加和因子">
              <el-option
                v-for="option in factorList"
                :key="option.id"
                :label="option.factorName"
                :value="option.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="报警级别">
            <el-select v-model="search.alarmLevel" placeholder="请选择报警级别"
                       clearable size="small" style="width: 200px">
              <el-option
                v-for="option in levelOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status" placeholder="请选择状态"
                       clearable size="small" style="width: 200px">
              <el-option
                v-for="option in statusOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="orange" size="small" @click="handleSearch" icon="el-icon-search">查询</el-button>
            <el-button type="primary" size="small" @click="handleReset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </template>

    <template #toolbar>
      <el-button type="orange" size="small" @click="handleAddModel" icon="el-icon-plus">规则</el-button>
    </template>

    <template #body>
      <data-wrapper>
        <!--  数据表格  -->
        <el-table
          ref="table" height="100%"
          border :data="list"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table"
          style="width:100%">
          <el-table-column label="序号" width="60" align="center" fixed>
            <template v-slot="{$index}">{{ formatTableIndex($index) }}</template>
          </el-table-column>
          <el-table-column prop="factorConfigId" label="加和因子名称" align="center">
            <template v-slot="{row}">
              {{ factorList.find((opt) => opt.id === row.factorConfigId) ? factorList.find((opt) => opt.id === row.factorConfigId).factorName : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="alarmLevel" label="报警级别" align="center">
            <template v-slot="{row}">
              {{ levelOptions.find((opt) => opt.value === row.alarmLevel) ? levelOptions.find((opt) => opt.value === row.alarmLevel).label : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="triggerCondition" label="触发条件" width="120" align="center">
            <template v-slot="{row}">
              {{ conditionsOptions.find((opt) => opt.value === row.triggerCondition) ? conditionsOptions.find((opt) => opt.value === row.triggerCondition).label : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="warnValue" label="预警值" width="110" align="center"/>
          <el-table-column prop="warnSiteNum" label="预警站数" width="110" align="center"/>
          <el-table-column prop="measures" label="应急措施" show-overflow-tooltip align="center"/>
          <el-table-column prop="createTime" label="创建日期" show-overflow-tooltip align="center"/>
          <el-table-column prop="action" label="动作" width="120" align="center">
            <template v-slot="{row}">
              {{ actionOptions.find((opt) => opt.value === row.action) ? actionOptions.find((opt) => opt.value === row.action).label : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="receiver" label="接收人" show-overflow-tooltip align="center">
            <template v-slot="{row}">
              {{ receiverPars(row.receiver) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" width="110" label="状态" align="center">
            <template v-slot="{row}">
              {{statusOptions.find((opt) => opt.value === row.status) ? statusOptions.find((opt) => opt.value === row.status).label : '--'}}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160">
            <template v-slot="{row}">
              <el-button size="mini" type="text" @click="handleEdit(row)">编辑</el-button>
              <el-button v-if="row.status === '0'" size="mini" type="text" @click="updateStatus(row.id,'1')">启用</el-button>
              <el-button v-else size="mini" type="text" style="color: #f56c6c;" @click="updateStatus(row.id,'0')">禁用</el-button>
              <el-button size="mini" type="text" style="color: #f56c6c;" @click="handleDelete(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--  对话框  -->
        <el-dialog
          :title="dialogTitle"
          top="10vh"
          show-overflow-tooltip
          :close-on-click-modal="false"
          :visible.sync="dialog.model"
          width="720px"
          @close="handleDialogClose">
          <el-form :model="form" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
            <el-form-item label="加和因子名称" prop="factorConfigId">
              <el-select v-model="form.factorConfigId" size="small" style="width: 100%" placeholder="请选择加和因子">
                <el-option
                  v-for="option in factorList"
                  :key="option.id"
                  :label="option.factorName"
                  :value="option.id"/>
              </el-select>
            </el-form-item>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item label="报警级别" prop="alarmLevel">
                  <el-select v-model="form.alarmLevel" size="small" style="width: 100%" placeholder="请选择报警级别">
                    <el-option
                      v-for="option in levelOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报警站数" prop="warnSiteNum">
                  <el-select v-model="form.warnSiteNum" size="small" style="width: 100%" placeholder="请选择报警站数">
                    <el-option
                      v-for="option in warnSiteNumOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item label="触发条件" prop="triggerCondition">
                  <el-select v-model="form.triggerCondition" size="small" style="width: 100%" placeholder="请选择触发条件">
                    <el-option
                      v-for="option in conditionsOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预警值" prop="warnValue">
                  <el-input size="small" :min="0" type="number" v-model="form.warnValue" placeholder="请输入预警值"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="应急措施" prop="measures">
              <el-input type="textarea" size="small" :rows="4" v-model="form.measures" placeholder="请输入应急措施"/>
            </el-form-item>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item label="动作" prop="action">
                  <el-checkbox-group v-model="form.action">
                    <el-checkbox
                      v-for="checkbox in actionOptions"
                      :key="checkbox.value"
                      :label="checkbox.value">
                      {{checkbox.label}}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态" prop="status">
                  <el-select v-model="form.status" placeholder="请选择状态" size="small" style="width: 100%">
                    <el-option
                      v-for="option in statusOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item v-show="form.action.length > 0" label="推送站内" prop="receiver">
              <el-select v-model="form.receiver" size="small" multiple style="width: 100%" placeholder="请选择推送站内用户">
                <el-option
                  v-for="option in userList"
                  :key="option.id"
                  :label="option.realName"
                  :value="option.id.toString()"/>
              </el-select>
            </el-form-item>
          </el-form>
          <template #footer>
            <div class="dialog-footer">
              <el-button @click="handleDialogClose">取消</el-button>
              <el-button type="primary" :loading="dialog.loading" @click="addConfig">提交</el-button>
            </div>
          </template>
        </el-dialog>
      </data-wrapper>
    </template>
    <!--  分页  -->
    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[20, 50, 100, 200, 500]"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next"
        background
        style="float:right">
      </el-pagination>
    </template>
  </layout-content>
</template>

<script>
import LayoutContent from '../../../components/Layout/Content'
import DataWrapper from '../../../components/Data/DataWrapper'
import BaseStore from '../../../components/BaseStore'
// 用户ID-名称映射
const createUserIdMap = (userList) => {
  const map = new Map()
  if (!Array.isArray(userList)) return map
  userList.forEach(item => {
    if (item.id && item.realName) {
      map.set(item.id.toString(), item.realName)
    }
  })
  return map
}
export default {
  name: 'AlarmConfig',
  routeInfo: {
    label: '报警配置',
    icon: 'fa fa-eye'
  },
  mixins: [BaseStore],
  components: {DataWrapper, LayoutContent},
  data () {
    return {
      search: {
        factorConfigId: '',
        alarmLevel: '',
        status: ''
      },
      statusOptions: [
        {value: '0', label: '禁用'},
        {value: '1', label: '启用'}
      ],
      levelOptions: [
        {value: '2', label: '二级报警'},
        {value: '3', label: '三级报警'}
      ],
      warnSiteNumOptions: [
        // {value: 0, label: '0'},
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'}
      ],
      actionOptions: [
        { label: '站内信', value: 'interiorLetter' }
      ],
      conditionsOptions: [
        { label: '>', value: '1' },
        { label: '≥', value: '2' },
        { label: '=', value: '3' },
        { label: '<', value: '4' },
        { label: '≤', value: '5' }
      ],
      factorList: [],
      userList: [],
      form: {
        factorConfigId: '',
        alarmLevel: '3',
        triggerCondition: '',
        warnValue: null,
        warnSiteNum: 1,
        measures: '',
        action: [],
        receiver: [],
        status: '0'
      },
      rules: {
        factorConfigId: [
          { required: true, message: '请选择加和因子', trigger: 'change' }
        ],
        alarmLevel: [
          { required: true, message: '请选择报警级别', trigger: 'change' }
        ],
        warnSiteNum: [
          { required: true, message: '请选择报警站数', trigger: 'change' }
        ],
        triggerCondition: [
          { required: true, message: '请选择触发条件', trigger: 'change' }
        ],
        warnValue: [
          { required: true, message: '请输入报警值', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        receiver: [
          { validator: this.checkReceiver, trigger: 'change' }
        ]
      },
      list: [],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      dialog: {
        title: 'add',
        model: false,
        loading: false
      },
      userIdMap: new Map()
    }
  },
  computed: {
    dialogTitle () {
      return this.dialog.title === 'edit' ? '编辑报警配置' : '新增报警配置'
    }
  },
  methods: {
    checkReceiver (rule, value, callback) {
      if (this.form.action.length > 0 && (!value || value.length <= 0)) {
        callback(new Error('请选择站内信推送用户'))
      }
      callback()
    },
    // 初始化加载
    initBase () {
      this.initDefaultData()
      this.fetchData()
    },
    // 加载默认数据
    initDefaultData () {
      this.$api['FactorRuleConfig'].getFactorConfigList().then((res) => { this.factorList = res || [] })
      this.$api['AlarmRuleConfig'].getUserList().then((res) => {
        this.userList = res || []
        this.userIdMap = createUserIdMap(this.userList)
      })
    },
    // 获取数据
    fetchData () {
      this.changeLoadStatus(true)
      const params = {
        ...this.search,
        size: this.pagination.pageSize,
        current: this.pagination.pageNum
      }
      this.$api['AlarmRuleConfig'].pageAlarmList(params)
        .then(res => {
          this.list = res.records || []
          this.pagination.total = res.total || 0
        })
        .catch(console.error)
        .finally(() => {
          this.changeLoadStatus(false)
        })
    },
    // 查询数据
    handleSearch () {
      this.pagination.pageNum = 1
      this.fetchData()
    },
    // 重置查询
    handleReset () {
      this.pagination.pageNum = 1
      this.search.factorConfigId = ''
      this.search.alarmLevel = ''
      this.search.status = ''
      this.fetchData()
    },
    // 分页数量改变
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.fetchData()
    },
    // 分页页码改变
    handleCurrentChange (currentPage) {
      this.pagination.pageNum = currentPage
      this.fetchData()
    },
    // 开启对话框
    handleAddModel () {
      this.dialog.title = 'add'
      this.show()
    },
    // 取消对话框
    resetForm (formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields()
        this.$refs[formName].clearValidate()
      }
    },
    // 对话框关闭处理
    handleDialogClose () {
      this.resetForm('ruleForm')
      this.hide()
      this.form = {
        factorConfigId: '',
        alarmLevel: '3',
        triggerCondition: '',
        warnValue: null,
        warnSiteNum: 1,
        measures: '',
        action: [],
        receiver: [],
        status: '0'
      }
    },
    // 提交表单
    addConfig () {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) return
        if (this.dialog.loading) return
        this.dialog.loading = true
        const params = {
          ...this.form,
          action: this.form.action.length > 0 ? this.form.action.join(',') : '',
          receiver: this.form.action.length > 0 && this.form.receiver.length > 0 ? this.form.receiver.join(',') : ''
        }
        let model
        if (this.dialog.title === 'add') {
          params.id = null
          model = this.$api['AlarmRuleConfig'].alarmRuleSave(params)
        } else {
          model = this.$api['AlarmRuleConfig'].alarmRuleUpdate(params)
        }
        if (model) {
          model.then(data => {
            if (data) {
              this.$notify({
                title: this.dialog.title === 'add' ? '新建成功' : '编辑成功',
                message: this.dialog.title === 'add' ? '新建报警配置保存成功' : '编辑报警配置保存成功',
                type: 'success',
                position: 'bottom-right'
              })
              this.handleDialogClose()
              this.fetchData()
            }
          })
            .catch(console.error)
            .finally(() => {
              this.dialog.loading = false
            })
        }
      })
    },
    // 开启对话框
    show () {
      this.dialog.model = true
    },
    // 关闭对话框
    hide () {
      this.dialog.model = false
    },
    // 格式化表格序号
    formatTableIndex (index) {
      return (this.pagination.pageNum - 1) * this.pagination.pageSize + index + 1
    },
    // 解析因子
    receiverPars (receiver) {
      if (!receiver) return '--'
      const idList = Array.from(receiver.split(','))
      const nameList = idList.map(id => this.userIdMap.get(id) || id)
      return nameList.join('、')
    },
    // 编辑配置
    handleEdit (row) {
      this.dialog.title = 'edit'
      this.form = {
        ...row,
        action: row.action ? row.action.split(',') : [],
        receiver: row.action && row.receiver ? row.receiver.split(',') : []
      }
      this.show()
    },
    // 启用因子配置
    updateStatus (id, status) {
      const title = status === '1' ? '启用' : '禁用'
      this.$confirm(`此操作将${title}该报警配置, 是否继续?`, `${title}提示`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeLoadStatus(true)
        this.$api['AlarmRuleConfig'].updAlarmStatus({id, status})
          .then(() => {
            this.$notify({
              title: '成功',
              message: `配置${title}成功!`,
              type: 'success',
              position: 'bottom-right'
            })
            this.fetchData()
          })
          .catch(console.error)
          .finally(() => {
            this.changeLoadStatus(false)
          })
      }).catch(() => {})
    },
    // 删除因子配置
    handleDelete (id) {
      this.$confirm(`此操作将会把该报警配置永久删除, 是否继续?`, `删除提示`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeLoadStatus(true)
        this.$api['AlarmRuleConfig'].delAlarmConfig({id})
          .then(() => {
            this.$notify({
              title: '成功',
              message: `配置删除成功!`,
              type: 'success',
              position: 'bottom-right'
            })
            this.fetchData()
          })
          .catch(console.error)
          .finally(() => {
            this.changeLoadStatus(false)
          })
      }).catch(() => {})
    }
  },
  created () {
    this.initBase()
  }
}
</script>

<style lang="scss" scoped>
.alarm-config-container {
  gap:12px;
  float:left;
  display:flex;
  margin-left:2em;
  margin-top: -4px;
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05AlarmRule/01AlarmConfig/index.vue